import {
  parseTempScopeConfig,
  buildTempUserDraftFromScope,
  buildNextEditableDepartments,
  buildTempScopeConfig,
} from './userManagementTempScopeUtils';
import { findDeptPathByName } from './userManagementOrgTreeUtils';

export function buildTempScopeStateMaps(tempUsers, orgTree) {
  const tempConfigMap = {};
  const selectedTemplateMap = {};
  const tempAuditGroupMap = {};
  const tempAuditDeptPathMap = {};

  (tempUsers || []).forEach((user) => {
    const scope = parseTempScopeConfig(user?.tempScopeConfig);
    const auditGroup = String(user?.auditGroup || '').trim();
    const storedPath = scope?.meta?.auditDeptPath && typeof scope.meta.auditDeptPath === 'object'
      ? {
          deptL1: String(scope.meta.auditDeptPath.deptL1 || '').trim(),
          deptL2: String(scope.meta.auditDeptPath.deptL2 || '').trim(),
          deptL3: String(scope.meta.auditDeptPath.deptL3 || '').trim(),
        }
      : null;
    const hasStoredPath = Boolean(storedPath && (storedPath.deptL1 || storedPath.deptL2 || storedPath.deptL3));
    const auditPathFound = findDeptPathByName(orgTree, auditGroup);
    tempConfigMap[user.id] = buildTempUserDraftFromScope(scope, auditGroup);
    selectedTemplateMap[user.id] = String(scope?.meta?.templateId || '').trim();
    tempAuditGroupMap[user.id] = auditGroup;
    tempAuditDeptPathMap[user.id] = {
      deptL1: hasStoredPath ? storedPath.deptL1 : (auditPathFound[0] || ''),
      deptL2: hasStoredPath ? storedPath.deptL2 : (auditPathFound[1] || ''),
      deptL3: hasStoredPath ? storedPath.deptL3 : (auditPathFound[2] || ''),
    };
  });

  return {
    tempConfigMap,
    selectedTemplateMap,
    tempAuditGroupMap,
    tempAuditDeptPathMap,
  };
}

export function buildTempConfigSavePayload({
  draft,
  auditGroup,
  auditDeptPath,
  selectedTemplateId,
  templates,
}) {
  const templateId = String(selectedTemplateId || '').trim();
  const templateName = (templates || []).find((template) => template.id === templateId)?.name || '';
  const nextEditableDepts = buildNextEditableDepartments(draft?.riskEditableDepartments, auditGroup);
  const tempScopeConfig = buildTempScopeConfig({
    ...(draft || {}),
    riskEditableDepartments: nextEditableDepts,
    templateId,
    templateName,
    auditDeptPath,
  });
  return {
    nextEditableDepts,
    requestBody: {
      auditGroup,
      tempScopeConfig,
    },
  };
}
